import styled, { css } from 'styled-components';

export const PaddingWrapper = styled.div<{padding: string, width?: string, wrapperCss: ReturnType<typeof css> | string}>`
  padding: ${({ padding }) => padding};
  ${({ width = '100%' }) => `
    width: ${width};
  `}
  ${(props) => props.wrapperCss}
`;
